// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","ArrowHeight":"30px","container":"G2b2fd6","tooltip__content":"Gefa68a","close":"Gb7f2a8"};